import { render, staticRenderFns } from "./RetailerCard.vue?vue&type=template&id=7e7c0fa9&"
import script from "./RetailerCard.vue?vue&type=script&lang=js&"
export * from "./RetailerCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports